<template>
  <span>
    <!-- <v-container pa-0 >
    <v-layout row wrap>-->
    <!-- {{$attrs}} -->
    <v-row class="ml-0 mr-0">
      <v-col cols="8" sm="8" class="px-0 mx-0">
        <v-menu
          ref="menu"
          :close-on-content-click="false"
          v-model="menu"
          transition="scale-transition"
          max-width="290px"
          min-width="290px"
          offset-y
          :nudge-right="-40"
          :nudge-top="20"
          :disabled="checkDisable"
          @click:clear="setClear"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-on="on"
              v-bind="$attrs"
              append-icon="event"
              v-model="formatted"
              @blur="dateValue = parseDate(formatted)"
              :clearable="('readonly' in $attrs)?false:true"
              :dense="('dense' in $attrs)?$attrs.dense:true"
              :filled="('filled' in $attrs)?$attrs.filled:true"
            ></v-text-field>
          </template>
          <v-date-picker
            :disabled="checkDisable"
            v-model="dateValue"
            locale="th-TH"
            :autosave="true"
            no-title
            scrollable
            actions
            @input="formatted = formatDate($event)"
            @change="save"
          >
            <template>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  text=""
                  color="primary"
                  :disabled="checkDisable"
                  @click="today()"
                >{{todayText}}</v-btn>
                <v-btn text="" color="primary" :disabled="checkDisable" @click="menu=false">Cancel</v-btn>
              </v-card-actions>
            </template>
          </v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="4" sm="4" class="px-0 mx-0">
        <v-menu
          :disabled="checkDisable"
          ref="menu2"
          v-model="menu2"
          :close-on-content-click="false"
          :nudge-right="40"
          :return-value.sync="timeValue"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on , attrs}">
            <v-text-field
              v-on="on"
              v-bind="$attrs"
              append-icon="mdi-clock-time-four-outline"
              v-model="timeValue"
              @blur="dateValue = parseTime(formatted)"
              label="time"
              :dense="('dense' in $attrs)?$attrs.dense:true"
              :filled="('filled' in $attrs)?$attrs.filled:true"
            ></v-text-field>
          </template>
          <v-time-picker
            :disabled="checkDisable"
            v-if="menu2"
            v-model="timeValue"
            full-width
            :use-seconds="true"
            format="24hr"
            @click:minute="$refs.menu2.save(timeValue);dateValue = parseTime(formatted)"
            @click:second="$refs.menu2.save(timeValue);dateValue = parseTime(formatted)"
          ></v-time-picker>
        </v-menu>
      </v-col>
    </v-row>
    <!-- </v-flex>
      </v-layout>
    </v-container>-->
  </span>
</template>

<script>
export default {
  data: () => ({
    menu: false,
    menu2: false,
    dateValue: null,
    timeValue: null,
    formatted: null,
    todayText: 'To Day'
  }),
  props: {
    // rules: {
    //   type: Array
    // },
    value: {
      type: String,
      default: ''
    },
    // label: {
    //   type: String,
    //   default: ''
    // },
    starttoday: {
      type: String,
      default: ''
    }
    // readonly: {
    //   type: Boolean,
    //   default: false
    // },
    // filled: {
    //   type: Boolean,
    //   default: false
    // },
  },
  mounted: function() {
    // console.log('starttoday', (this.starttoday === 'true'))
    if (this.starttoday === 'true') {
      // console.log('starttoday', (new Date()).toISOString().slice(0, 10))
      this.setToday()
    } else {
      // console.log('starttoday', (new Date()).toISOString().slice(0, 10))
      // this.value = ''
    }
    this.formatValue()
  },
  watch: {
    value() {
      // console.log('watch dateTimeInputer value',this.value)
      this.formatValue()
      // if (this.value) {
      //   let d = (this.value.slice(0, 10))
      //   d += ' ' + (this.value.slice(11, 19))
      //   if (d !== this.dateValue) {
      //     this.formatValue()
      //   }
      // }
    },
    formatted() {},
    dateValue(value, oldValue) {
      if (value === null) {
        this.setNull()
      }
    }
  },
  created() {
    // this.moment = window.moment
    // console.log(this.moment)
  },
  computed: {
    checkDisable() {
      return 'readonly' in this.$attrs ? true : false || 'disabled' in this.$attrs ? !!this.$attrs.disabled : false
    }
  },
  methods: {
    save(date) {
      this.$refs.menu.save(date)
      this.menu2 = true
    },
    formatDate(date) {
      // console.log('formatDate', date)
      if (!date) {
        return null
      }

      var [year, month, day] = date.split('-')
      year = parseInt(year) + 543
      if (this.timeValue === null) {
        this.timeValue = '00:00:00'
      }
      this.$emit('input', this.dateValue + 'T' + this.timeValue)
      return `${day}/${month}/${year}`
    },
    parseDate(datetime) {
      // console.log('parseDate', datetime)
      if (!datetime) {
        return null
      }
      let [date, time] = datetime.split(' ')
      if (!this.timeValue) {
        this.timeValue = '00:00:00'
      }
      time = this.timeValue
      var [day, month, year] = date.split('/')
      // console.log('parseDate - year', year)
      year = parseInt(year) - 543
      this.$emit('input', `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}T${time}`)
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}T${time}`
    },
    parseTime(datetime) {
      // console.log('parseTime', datetime)
      if (!datetime) {
        return null
      }
      let [date, time] = datetime.split(' ')
      if (this.timeValue === null) {
        this.timeValue = '00:00:00'
      }
      time = this.timeValue
      var [day, month, year] = date.split('/')
      // console.log('parseDate - year', year)
      year = parseInt(year) - 543
      this.$emit('input', `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}T${time}`)
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}T${time}`
    },
    today() {
      // console.log(e)
      if (this.todayText !== 'Delete') {
        this.setToday()
        // this.todayText = 'Delete'
      } else {
        this.setNull()
        // this.todayText = 'To Day'
      }
      //this.$emit('input', this.dateValue+' '+this.timeValue)
    },
    setToday() {
      const d = new Date()
      d.setUTCHours(d.getUTCHours() + -d.getTimezoneOffset() / 60)
      const tod = d.toISOString().slice(0, 10)
      const tot = d.toISOString().slice(11, 19)
      // this.value = tod
      this.dateValue = tod
      this.timeValue = tot
      this.$refs.menu2.save(this.timeValue)
      this.formatted = this.formatDate(this.dateValue)
      this.todayText = 'Delete'
      this.$emit('input', this.dateValue + 'T' + this.timeValue)
    },
    setNull() {
      this.dateValue = null
      this.timeValue = null
      this.formatted = ''
      this.todayText = 'To Day'
      this.$emit('input', this.dateValue)
    },
    setClear() {
      this.dateValue = ''
      this.timeValue = ''
      this.formatted = ''
      this.todayText = 'To Day'
      this.$emit('input', this.dateValue)
    },
    formatValue: function() {
      // if (this.dateValue !== null) {
      //   this.todayText = 'Delete'
      // // console.log('formatValue-01', this.value)
      // // this.dateValue = new Date(this.value.slice(0, 10))
      //   this.dateValue = (this.value.slice(0, 10))
      //   this.timeValue = (this.value.slice(11, 19))
      //   this.formatted = this.formatDate(this.dateValue)
      // } else {
      //   this.dateValue = null
      //   this.timeValue = null
      //   this.formatted = ''
      // }

      if (this.value === null) {
        this.dateValue = null
        this.timeValue = null
        this.formatted = ''
        this.todayText = 'Today'
        return
      }
      this.dateValue = this.value.slice(0, 10)
      this.timeValue = this.value.slice(11, 19)
      this.formatted = this.formatDate(this.dateValue)
      const tod = new Date().toISOString().slice(0, 10)
      if (tod === this.dateValue) {
        this.todayText = 'Delete'
      }

      // const tod = (new Date()).toISOString().slice(0, 10)

      // this.formatted = this.Date2Text(this.value)
      // this.$refs.Input.value = this.Date2Text(this.value)
      // console.log('formatValue-03  ok', this.dateValue)
    }
  }
}
</script>

<style scoped>
</style>
